<div class="row-container">
  <div class="row row-condensed align-items-center mb-4 pb-3 d-print-none">
    <div class="col-12 col-md-auto">
      @if (canDownloadReport()) {
        <cfp-building-pdf-download-button
          [url]="url()"
          [fileName]="fileName()"
          [labelGroup]="labelGroup()"
          [dataAnalytics]="'downloadBuildingReportButton'"
        />
      }
      @if (hasBuildingReportFeedback()) {
        <cfp-button [buttonStyle]="'secondary'" [class.ms-2]="canDownloadReport()" (clicked)="showFeedback.emit()">
          {{ 'buildingReport.Feedback' | translate }}
        </cfp-button>
      }
    </div>
    @if (canShareReport()) {
      <div class="col-12 col-md-auto mt-3 mt-lg-0">
        <cfp-button
          [dataTest]="'buildingReportShareReport'"
          dataAnalytics="buildingReportShareReport"
          (clicked)="share()"
          [style]="'secondary'"
          [classes]="'d-block w-100 d-md-inline-block'"
        >
          <i class="fa fa-share me-2" aria-hidden="true"></i>{{ 'shareReport' | translate }}
        </cfp-button>
      </div>
      <div class="col-12 col-md-auto mt-3 mt-lg-0">
        @if (building().publicSharedId) {
          <cfp-badge [badgeStyle]="'info'">
            <cfp-icon [icon]="'exclamation-circle'" [classes]="'me-2'" />
            {{ 'buildingShareModal.body.warning' | translate }}
          </cfp-badge>
        }
      </div>
    }
    <ng-content />
  </div>
</div>
